var _path, _path2, _path3, _circle, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvert2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.04 53.7711L59.2448 53.9215C57.2871 56.8266 54.6523 59.3443 51.4105 61.216C40.8318 67.3236 27.5265 64.3933 20.5 54.8135",
    stroke: "#FCB800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8272 23.3933L41.3551 17.0785C44.8498 17.3214 48.3477 18.3443 51.5895 20.216C62.1682 26.3236 66.2832 39.3115 61.5 50.1865",
    stroke: "#FD5B01",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1328 44.8356L18.4001 51C16.8631 47.852 16 44.3113 16 40.568C16 28.3528 25.1903 18.2951 37 17",
    stroke: "#8372FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 48,
    r: 4,
    stroke: "#8372FF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48L42.55 32",
    stroke: "#8372FF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5391 32C48.5391 32.0011 48.539 32.0026 48.5384 32.0054C48.5378 32.0084 48.5363 32.0146 48.5323 32.0243C48.5242 32.044 48.5049 32.0811 48.4613 32.1326C48.37 32.2405 48.1989 32.3805 47.9203 32.5198C47.3625 32.7987 46.522 33 45.5391 33C44.5561 33 43.7156 32.7987 43.1578 32.5198C42.8793 32.3805 42.7081 32.2405 42.6169 32.1326C42.5732 32.0811 42.5539 32.044 42.5458 32.0243C42.5418 32.0146 42.5403 32.0084 42.5397 32.0054C42.5391 32.0026 42.5391 32.0011 42.5391 32C42.5391 31.9989 42.5391 31.9974 42.5397 31.9946C42.5403 31.9916 42.5418 31.9854 42.5458 31.9757C42.5539 31.956 42.5732 31.9189 42.6169 31.8674C42.7081 31.7595 42.8793 31.6195 43.1578 31.4802C43.7156 31.2013 44.5561 31 45.5391 31C46.522 31 47.3625 31.2013 47.9203 31.4802C48.1989 31.6195 48.37 31.7595 48.4613 31.8674C48.5049 31.9189 48.5242 31.956 48.5323 31.9757C48.5363 31.9854 48.5378 31.9916 48.5384 31.9946C48.539 31.9974 48.5391 31.9989 48.5391 32Z",
    stroke: "#8372FF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert2);
export default __webpack_public_path__ + "static/media/Convert2.b8e5e693.svg";
export { ForwardRef as ReactComponent };